import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { formatToDateTime } from "../main/formatToDateTime";
import { Link } from "react-router-dom";
import * as html2pdf from "html2pdf.js";

export default function StuffingTallySheet() {
  const pdfRef = useRef();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [Data, setData] = useState(null);

  const fetchData = async (id) => {
    setLoading(true);
    const url = `https://ctas.live/backend/api/get/tally/stuffing/${id}`;
    try {
      const response = await axios.get(url);
      if (response?.data?.status === "success") {
        setData(response?.data?.data);
      } else {
        Swal.fire({
          icon: response?.data?.status,
          text: response?.data?.message,
          timer: 3000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error Fetching Data: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const id = searchParams.get("id");
    if (id) {
      fetchData(id);
    }
  }, [searchParams]);

  const handleDownload = () => {
    const element = pdfRef.current;

    const opt = {
      margin: [0.2, 0.2, 0.2, 0.2], // top, left, bottom, right in inches
      filename: "Tally Sheet.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        scale: 3, // Higher scale = better quality
        useCORS: true, // fixes image loading issue
      },
      jsPDF: {
        unit: "in",
        format: "a3", // standard A4
        orientation: "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] }, // try to avoid breaking elements
    };

    html2pdf().set(opt).from(element).save();
  };

  const [cclsPackages, setCclsPackages] = useState(0);
  const [totalPackages, setTotalPackages] = useState(0);
  const [totalPackagesWeight, setTotalPackagesWeight] = useState(0);
  const [totalArea, setTotalArea] = useState(0);

  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-GB");

  useEffect(() => {
    if (Data && Data.stuffing_shipping_bill_details) {
      let cclsPackages = 0;
      let totalPackages = 0;
      let totalPackagesWeight = 0;
      let totalArea = 0;

      Data.stuffing_shipping_bill_details.forEach((Details) => {
        cclsPackages += parseInt(Details.ccls_no_of_pkg_declared ?? 0);
        totalPackages += parseInt(Details.no_of_packages_declared ?? 0);
        totalPackagesWeight += parseFloat(Details.package_weight ?? 0);

        if (Array.isArray(Details?.grid_area)) {
          Details.grid_area.forEach((grid) => {
            totalArea += parseFloat(grid.area ?? 0);
          });
        }
      });
      setCclsPackages(cclsPackages);
      setTotalPackages(totalPackages);
      setTotalPackagesWeight(totalPackagesWeight);
      setTotalArea(totalArea);
    }
  }, [Data]);

  if (!Data) {
    return (
      <div className="container mt-10">
        <div className="d-flex justify-content-center">
          <div className=" w-100 alert alert-danger" role="alert">
            No data received yet.
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="sk-chase-dot" />
            ))}
          </div>
        </div>
      )}
      <div className="col-lg-11 my-4 mx-auto" ref={pdfRef}>
        <div className="card card-body p-4">
          <div className="row">
            <div className="col">
              <span> S.No:</span> <b> {Data.id}</b>
              <br />
              <span>Date: </span> <b>{formattedDate}</b>
            </div>
            <div className="col text-center">
              <b>Cargo Handling Operator </b>
              <br />
              <span>Container Stuffing Tally Sheet</span>
            </div>
            <div className="col text-end">
              <Link
                to="/export-reports"
                className="btn btn-label-primary waves-effect waves-light me-1"
              >
                <i className="ri-arrow-left-line ri-20px" />
              </Link>
              <button
                onClick={() => window.print()}
                className="btn btn-label-info"
              >
                Print
              </button>
              <button
                onClick={handleDownload}
                className="btn btn-label-info ms-1"
              >
                Down...
              </button>
            </div>
          </div>
          <hr />
          <div className="row px-10 top">
            <table className="table table-borderless mb-4 table-font text-nowrap">
              <tbody>
                <tr>
                  <td className="text-start px-10">Sbill Number</td>
                  <td className="text-wrap text-start px-10">
                    <strong>
                      :
                      {Data?.stuffing_shipping_bill_details?.map((bills, i) => (
                        <>
                          <span key={i}>{bills.shipping_bill_number} ,</span>
                          {(i + 1) % 3 === 0 && <br />}
                        </>
                      ))}
                    </strong>
                  </td>
                  <td className="text-start px-10">Total No Of Containers</td>
                  <td className="text-start px-10">
                    <strong>: 1 </strong>
                  </td>
                </tr>
                <tr>
                  <td className="text-start px-10">CRN Number</td>
                  <td className="text-start px-10">
                    <strong>: {Data.crn_number} </strong>
                  </td>
                  <td className="text-start px-10">Sline Code</td>
                  <td className="text-start px-10">
                    <strong>: {Data.shipping_liner_code}</strong>
                  </td>
                </tr>
                <tr>
                  <td className="text-start px-10">Container Number</td>
                  <td className="text-start px-10">
                    <strong>: {Data.container_number}</strong>
                  </td>
                  <td className="text-start px-10">Declared Gross Weight</td>
                  <td className="text-start px-10">
                    <strong>: {Data.gross_weight} Tons</strong>
                  </td>
                </tr>
                <tr>
                  <td className="text-start px-10">Container Size</td>
                  <td className="text-start px-10">
                    <strong>: {Data.container_size}</strong>
                  </td>
                  <td className="text-start px-10">Warehouse Name</td>
                  <td className="text-start px-10">
                    <strong>: Export Warehouse</strong>
                  </td>
                </tr>
                <tr>
                  <td className="text-start px-10">Type</td>
                  <td className="text-start px-10">
                    <strong className="text-uppercase">: {Data.type}</strong>
                  </td>
                  <td className="text-start px-10">Start Date & Time</td>
                  <td className="text-start px-10">
                    <strong>: {formatToDateTime(Data.start_time)}</strong>
                  </td>
                </tr>
                <tr>
                  <td className="text-start px-10">GW Port Code</td>
                  <td className="text-start px-10">
                    <strong>:{Data.gw_port}</strong>
                  </td>
                  <td className="text-start px-10">End Date & Time</td>
                  <td className="text-start px-10">
                    <strong>: {formatToDateTime(Data.end_time)}</strong>
                  </td>
                </tr>
                <tr>
                  <td className="text-start px-10">Cha Code</td>
                  <td className="text-start px-10">
                    <strong>:{Data.cha_code}</strong>
                  </td>
                  <td className="text-start px-10">Excess / Short Packages</td>
                  <td className="text-start px-10">
                    <strong>: {Math.max(0, cclsPackages - totalPackages)}{" "}</strong>
                  </td>
                </tr>
                <tr>
                  <td className="text-start px-10">
                    Total No. of Packages Declared
                  </td>
                  <td className="text-start px-10">
                    <strong>: {cclsPackages}</strong>
                  </td>
                  <td className="text-start px-10">Exporter Name</td>
                  <td className="text-start px-10">
                    <strong>: {Data?.carting_container?.exporter_name}</strong>
                  </td>
                </tr>
                <tr>
                  <td className="text-start px-10">Handling Type</td>
                  <td className="text-start px-10">
                    <strong>: {Data.handling_type}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="row main">
            <table className="table table-bordered table-font">
              <thead className="">
                <tr>
                  <th>Container Number</th>
                  <th>SBill No</th>
                  <th>Pkg Code</th>
                  <th>Cargo Description (Code)</th>
                  <th>No of Pkgs</th>
                  <th>Pkg Weight</th>
                  <th>Grid Locations</th>
                  <th>Area (Sqm)</th>
                </tr>
              </thead>
              <tbody>
                {Data?.stuffing_shipping_bill_details?.map((Details, i) => (
                  <tr key={i}>
                    <td>{Data.container_number}</td>
                    <td>{Details.shipping_bill_number}</td>
                    <td>{Details.package_code}</td>

                    <td>
                      {Details.commodity_description} ({Details.commodity_code})
                    </td>
                    <td>{Details.no_of_packages_declared}</td>
                    <td>{Details.package_weight}</td>

                    <td>
                      {Details?.grid_area?.map((grid_area) => (
                        <>
                          <span>{grid_area.grid_locations} </span> <br />
                        </>
                      ))}
                    </td>
                    <td>
                      {Details?.grid_area?.map((grid_area) => (
                        <>
                          <span>{grid_area.area} </span> <br />
                        </>
                      ))}
                    </td>
                  </tr>
                ))}
                {Data?.stuffing_shipping_bill_details
                  ? Array.from(
                      {
                        length: Math.max(
                          0,
                          10 - Data.stuffing_shipping_bill_details.length
                        ),
                      },
                      (_, i) => (
                        <tr key={i}>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      )
                    )
                  : Array.from({ length: 10 }, (_, i) => (
                      <tr key={i}>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    ))}

                <tr>
                  <td>Total</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{totalPackages}</td>
                  <td>
                    {totalPackagesWeight
                      ? Number(totalPackagesWeight).toFixed(2)
                      : 0} Tons
                  </td>
                  <td></td>
                  <td>{totalArea}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="row border" style={{ height: "150px" }}>
            <div className="col-md-12">
              <p>
                <b>Remarks : </b>
                <span> </span>
              </p>
            </div>
          </div>
          <div className="row mt-1 align-items-end" style={{ height: "130px" }}>
            <div className="col">
              <span>
                Said to contain received cargo in sound condition and to my
                entire satisfaction.
              </span>
            </div>
            <div className="col text-center">
              <span>Tallied By</span> <br />
              <b>--</b>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
